import { usePostHog } from "posthog-js/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import content_my from "./content_my.json";
import {
  ButtonStyled,
  GridStyledTagline,
  GridTagline,
  TaglineSubtitle,
  TaglineTitle,
} from "./styles";

export default function SubEmployerHeader(props) {
  const { onScrollToPackage } = props;
  const [tagline, setTagline] = useState([]);

  const dispatch = useDispatch();

  async function fetchData() {
    // const responseApi = await dispatch(fetchEmployerTagline());

    const response = content_my;

    const { tagline } = response || {};

    setTagline(tagline);
  }

  const posthog = usePostHog();
  const buttonCTA = "See Hiring Packages";
  const buttonColour = "yellow";

  function triggerInfoDialog() {
    onScrollToPackage();
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <GridStyledTagline>
        {tagline?.slice(0, 1).map((tagline) => {
          return (
            <>
              <GridTagline>
                <TaglineTitle>{tagline?.mainTitle}</TaglineTitle>
                <TaglineSubtitle>{tagline?.subTitle}</TaglineSubtitle>
              </GridTagline>
            </>
          );
        })}

        <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
      </GridStyledTagline>
    </>
  );
}
